/*
 * @Author: Dong
 * @Date: 2022-04-07 18:34:45
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-06-14 14:33:39
 */
import React, { useRef } from 'react';
import Package from '../Package';
import { Divider, Radio } from 'sup-ui';
import { SelectedVersionType, UpdateQueueType } from '../types';
import styles from './index.less';
import messages from '../messages';
import { useIntl } from 'react-intl';
interface PropsType {
  dataSource: any;
  uploadQueue?: Array<UpdateQueueType>;
  type?: string;
  selectedVersions: SelectedVersionType;
  changeSelect?: (id: string, name: string) => void;
  deleteTask?: (name: string, version: string) => void;
  cancelUpload?: (name: string, version: string) => void;
  handleRetry?: (data: any) => void;
  retestCheck?: (name: string, version: string) => void;
  operationType: string;
}

const List = (props: PropsType) => {
  const intl = useIntl();
  const {
    dataSource,
    selectedVersions,
    type,
    changeSelect,
    deleteTask,
    cancelUpload,
    handleRetry,
    retestCheck,
    operationType,
  } = props;

  const selectValue = useRef<any>(null); // 单选框的值

  const handleChange = (value: any) => {
    if (!changeSelect || !value?.target?.PackageInfo) return;
    const { archiveId, name } = value.target.PackageInfo;
    selectValue.current = { ...selectValue.current, [name]: archiveId };
    changeSelect(archiveId, name);
  };

  const radioStyle = {
    display: 'block',
    borderBottom: '1px dashed #dbe2e9',
  };

  // 点击单选按切换选中取消
  const toggleSelect = (name: string) => {
    if (!changeSelect) return;
    if (selectedVersions[name]) {
      changeSelect('', name);
      selectValue.current = { ...selectValue.current, [name]: '' };
    }
  };

  const renderPackage = (info: any, detailsInfo: any) => {
    const { name, img, title, subTitle, disabled, disabledTip } = info;
    return (
      <Package
        name={name}
        img={img}
        title={title}
        subTitle={subTitle}
        type={type}
        {...detailsInfo}
        disabledTip={disabledTip}
        disabled={disabled}
        changeSelect={changeSelect}
        handleDelete={deleteTask}
        selectedVersions={selectedVersions}
        cancelUpload={cancelUpload}
        handleRetry={handleRetry}
        retestCheck={retestCheck}
        operationType={operationType}
      />
    );
  };
  return (
    <div className={styles.packageList}>
      {(dataSource || [])?.map((item: any, index: number) => {
        const { name } = item;

        return (
          <div key={index}>
            <Radio.Group onChange={handleChange} value={selectedVersions[name]}>
              {item?.specifics?.map((i: any) => {
                // 根据是否有上传状态判断是可选择项目
                return !i.isAvailable ? (
                  <div style={{ padding: '20px 0' }}>{renderPackage(item, i)}</div>
                ) : (
                  <Radio
                    PackageInfo={{ ...item, ...i }}
                    key={i.archiveId}
                    value={i.archiveId}
                    style={radioStyle}
                    onClick={() => {
                      toggleSelect(name);
                    }}
                  >
                    {renderPackage(item, i)}
                    <span className={styles.radioText}>
                      {selectValue.current && selectValue.current[name] === i.archiveId
                        ? intl.formatMessage(messages.selected)
                        : intl.formatMessage(messages.selectable)}
                    </span>
                  </Radio>
                );
              })}
            </Radio.Group>
            {index < dataSource?.length - 1 && <Divider />}
          </div>
        );
      })}
    </div>
  );
};

export default List;
